module.exports = __webpack_public_path__ + "static/media/air-canada.f67ba08e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/air-canada.jpg
// module id = 504
// module chunks = 0